/* Local dependencies */
import { Warehouse } from '../../types';
import {
  ResetUpdateWarehouseError,
  ResetUpdateWarehouseState,
  UpdateWarehouseActionTypes,
  UpdateWarehouseError,
  UpdateWarehouseInput,
  UpdateWarehouseRequest,
  UpdateWarehouseSuccess,
} from './types';

export function updateWarehouse(input: UpdateWarehouseInput): UpdateWarehouseRequest {
  return {
    type: UpdateWarehouseActionTypes.UPDATE_WAREHOUSE,
    input,
  };
}

export function updateWarehouseSuccess(warehouse: Warehouse): UpdateWarehouseSuccess {
  return {
    type: UpdateWarehouseActionTypes.UPDATE_WAREHOUSE_SUCCESS,
    warehouse,
  };
}

export function updateWarehouseError(error: Error): UpdateWarehouseError {
  return {
    type: UpdateWarehouseActionTypes.UPDATE_WAREHOUSE_ERROR,
    error,
  };
}

export function resetUpdateWarehouseError(): ResetUpdateWarehouseError {
  return {
    type: UpdateWarehouseActionTypes.UPDATE_WAREHOUSE_RESET_ERROR,
  };
}

export function resetUpdateWarehouseState(): ResetUpdateWarehouseState {
  return {
    type: UpdateWarehouseActionTypes.UPDATE_WAREHOUSE_RESET_STATE,
  };
}
